import React from 'react';
import { useCalculateTotalTravelTime } from 'entities/navigation/hooks';
import { StatisticCard } from '../StatisticCard/StatisticCard';
import { useIntl } from 'react-intl';

export const TravelTimeCard = () => {
  const totalTravelTime = useCalculateTotalTravelTime();
  const { formatMessage } = useIntl();

  return (
    <StatisticCard iconKind="timer" primaryText={totalTravelTime} secondaryText={formatMessage({ id: 'travelTime' })} />
  );
};
